import { cn } from "@newxsystems/shared";
import type { BlockColumnCount } from "@newxsystems/types";
import { Children, createContext } from "react";
import type { IResponsiveBlockGridProps } from "./ResponsiveBlockGrid.props";

const columnClasses: Record<BlockColumnCount, string> = {
  1: "grid-cols-1",
  2: "grid-cols-1 md:grid-cols-2",
  3: "grid-cols-1 md:grid-cols-3",
  4: "grid-cols-1 md:grid-cols-3 lg:grid-cols-4",
};

export const ResponsiveBlockGridColumnContext = createContext<BlockColumnCount>(3);

export const ResponsiveBlockGrid = ({
  children,
  className,
  columnCount = 3,
  ...attributes
}: IResponsiveBlockGridProps) => {
  let itemCount = 0;

  Children.forEach(children, (child) => {
    if (child !== null && child !== undefined && typeof child !== "boolean") {
      itemCount += 1;
    }
  });

  const availableColumnCount: BlockColumnCount =
    itemCount <= 1 ? 1 : itemCount === 2 ? 2 : itemCount === 3 ? 3 : 4;
  const authoredColumnCount = columnCount ?? 3;
  const effectiveColumnCount =
    authoredColumnCount < availableColumnCount ? authoredColumnCount : availableColumnCount;

  return (
    <ResponsiveBlockGridColumnContext value={effectiveColumnCount}>
      <div className={cn("grid", columnClasses[effectiveColumnCount], className)} {...attributes}>
        {children}
      </div>
    </ResponsiveBlockGridColumnContext>
  );
};

ResponsiveBlockGrid.displayName = "Shared::ResponsiveBlockGrid";
